var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3574",
    "data-name": "Group 3574",
    transform: "translate(-327 -173)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(327 173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3932",
    "data-name": "Group 3932",
    transform: "translate(332 183.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M21.283,27.443h0a1.844,1.844,0,0,0-1.831,1.851h0a1.887,1.887,0,0,0,.335,1.086l-3.2,3.386a1.772,1.772,0,0,0-.6-.111h0a1.77,1.77,0,0,0-.677.135l-3.479-3.742a1.9,1.9,0,0,0-.355-2.105,1.79,1.79,0,0,0-1.282-.553h-.011a1.786,1.786,0,0,0-1.282.537,1.9,1.9,0,0,0-.214,2.4L5.489,33.717a1.783,1.783,0,0,0-.6-.111H4.874a1.787,1.787,0,0,0-1.282.537,1.9,1.9,0,0,0-.047,2.62l.032.033a1.79,1.79,0,0,0,1.282.553H4.87a1.786,1.786,0,0,0,1.282-.537,1.9,1.9,0,0,0,.062-2.59l3.118-3.3a1.779,1.779,0,0,0,.831.221h.011a1.777,1.777,0,0,0,1.1-.385l3.315,3.549a1.881,1.881,0,0,0-.451,1.2h0a1.846,1.846,0,0,0,1.811,1.877h0a1.845,1.845,0,0,0,1.822-1.855,1.882,1.882,0,0,0-.481-1.269l3.118-3.3a1.774,1.774,0,0,0,.829.221h0a1.868,1.868,0,0,0,0-3.733Z",
    transform: "translate(-3.045 -27.39)",
    fill: "#1b453e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefGraph);
export default __webpack_public_path__ + "static/media/ref-graph.e331d2fd99deb8e2033cbf41f38e36fa.svg";
export { ForwardRef as ReactComponent };